import { Link } from "react-router-dom";

function Logo() {
  return (
    <Link to="/">
      <div className="w-12 h-12 rounded-full bg-gradient-to-br from-indigo-500 to-pink-500 flex items-center justify-center text-white font-bold cursor-pointer">
        JG
      </div>
    </Link>
  );
}

export default Logo;
